<div class="contenitore" [style.padding-top.px]="paddingTop">
  <div class="titolo-archiviato">
    <div *ngIf="titoloSafe" class="titolo" [innerHTML]="titoloSafe"></div>

    @if (isArchiviato) {
      <div class="targhettina-archiviato">
        <mat-icon class="material-icons-outlined" style="transform: scale(0.5)">
          inventory_2
        </mat-icon>
        ARCHIVIATO
      </div>
    }
  </div>

  <div *ngIf="subTitoloSafe" class="sub-titolo" [innerHTML]="subTitoloSafe"></div>
</div>
